import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const GeneratorBackgroundIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="126" height="382" viewBox="0 0 126 382" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle
        cx="7"
        cy="7"
        r="6.5"
        fill={fillColor || 'url(#paint0_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint1_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="7"
        r="6.5"
        fill={fillColor || 'url(#paint2_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint3_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="7"
        r="6.5"
        fill={fillColor || 'url(#paint4_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint5_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="7"
        r="6.5"
        fill={fillColor || 'url(#paint6_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint7_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="7"
        r="6.5"
        fill={fillColor || 'url(#paint8_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint9_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="7"
        r="6.5"
        fill={fillColor || 'url(#paint10_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint11_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="7"
        r="6.5"
        fill={fillColor || 'url(#paint12_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint13_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="7"
        r="6.5"
        fill={fillColor || 'url(#paint14_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint15_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="23"
        r="6.5"
        fill={fillColor || 'url(#paint16_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint17_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="23"
        r="6.5"
        fill={fillColor || 'url(#paint18_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint19_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="23"
        r="6.5"
        fill={fillColor || 'url(#paint20_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint21_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="23"
        r="6.5"
        fill={fillColor || 'url(#paint22_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint23_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="23"
        r="6.5"
        fill={fillColor || 'url(#paint24_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint25_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="23"
        r="6.5"
        fill={fillColor || 'url(#paint26_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint27_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="23"
        r="6.5"
        fill={fillColor || 'url(#paint28_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint29_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="23"
        r="6.5"
        fill={fillColor || 'url(#paint30_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint31_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="39"
        r="6.5"
        fill={fillColor || 'url(#paint32_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint33_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="39"
        r="6.5"
        fill={fillColor || 'url(#paint34_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint35_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="39"
        r="6.5"
        fill={fillColor || 'url(#paint36_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint37_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="39"
        r="6.5"
        fill={fillColor || 'url(#paint38_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint39_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="39"
        r="6.5"
        fill={fillColor || 'url(#paint40_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint41_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="39"
        r="6.5"
        fill={fillColor || 'url(#paint42_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint43_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="39"
        r="6.5"
        fill={fillColor || 'url(#paint44_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint45_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="39"
        r="6.5"
        fill={fillColor || 'url(#paint46_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint47_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="55"
        r="6.5"
        fill={fillColor || 'url(#paint48_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint49_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="55"
        r="6.5"
        fill={fillColor || 'url(#paint50_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint51_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="55"
        r="6.5"
        fill={fillColor || 'url(#paint52_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint53_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="55"
        r="6.5"
        fill={fillColor || 'url(#paint54_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint55_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="55"
        r="6.5"
        fill={fillColor || 'url(#paint56_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint57_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="55"
        r="6.5"
        fill={fillColor || 'url(#paint58_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint59_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="55"
        r="6.5"
        fill={fillColor || 'url(#paint60_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint61_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="55"
        r="6.5"
        fill={fillColor || 'url(#paint62_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint63_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="71"
        r="6.5"
        fill={fillColor || 'url(#paint64_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint65_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="71"
        r="6.5"
        fill={fillColor || 'url(#paint66_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint67_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="71"
        r="6.5"
        fill={fillColor || 'url(#paint68_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint69_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="71"
        r="6.5"
        fill={fillColor || 'url(#paint70_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint71_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="71"
        r="6.5"
        fill={fillColor || 'url(#paint72_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint73_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="71"
        r="6.5"
        fill={fillColor || 'url(#paint74_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint75_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="71"
        r="6.5"
        fill={fillColor || 'url(#paint76_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint77_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="71"
        r="6.5"
        fill={fillColor || 'url(#paint78_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint79_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="87"
        r="6.5"
        fill={fillColor || 'url(#paint80_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint81_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="87"
        r="6.5"
        fill={fillColor || 'url(#paint82_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint83_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="87"
        r="6.5"
        fill={fillColor || 'url(#paint84_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint85_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="87"
        r="6.5"
        fill={fillColor || 'url(#paint86_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint87_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="87"
        r="6.5"
        fill={fillColor || 'url(#paint88_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint89_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="87"
        r="6.5"
        fill={fillColor || 'url(#paint90_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint91_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="87"
        r="6.5"
        fill={fillColor || 'url(#paint92_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint93_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="87"
        r="6.5"
        fill={fillColor || 'url(#paint94_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint95_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="103"
        r="6.5"
        fill={fillColor || 'url(#paint96_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint97_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="103"
        r="6.5"
        fill={fillColor || 'url(#paint98_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint99_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="103"
        r="6.5"
        fill={fillColor || 'url(#paint100_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint101_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="103"
        r="6.5"
        fill={fillColor || 'url(#paint102_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint103_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="103"
        r="6.5"
        fill={fillColor || 'url(#paint104_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint105_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="103"
        r="6.5"
        fill={fillColor || 'url(#paint106_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint107_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="103"
        r="6.5"
        fill={fillColor || 'url(#paint108_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint109_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="103"
        r="6.5"
        fill={fillColor || 'url(#paint110_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint111_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="119"
        r="6.5"
        fill={fillColor || 'url(#paint112_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint113_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="119"
        r="6.5"
        fill={fillColor || 'url(#paint114_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint115_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="119"
        r="6.5"
        fill={fillColor || 'url(#paint116_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint117_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="119"
        r="6.5"
        fill={fillColor || 'url(#paint118_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint119_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="119"
        r="6.5"
        fill={fillColor || 'url(#paint120_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint121_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="119"
        r="6.5"
        fill={fillColor || 'url(#paint122_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint123_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="119"
        r="6.5"
        fill={fillColor || 'url(#paint124_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint125_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="119"
        r="6.5"
        fill={fillColor || 'url(#paint126_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint127_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="135"
        r="6.5"
        fill={fillColor || 'url(#paint128_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint129_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="135"
        r="6.5"
        fill={fillColor || 'url(#paint130_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint131_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="135"
        r="6.5"
        fill={fillColor || 'url(#paint132_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint133_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="135"
        r="6.5"
        fill={fillColor || 'url(#paint134_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint135_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="135"
        r="6.5"
        fill={fillColor || 'url(#paint136_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint137_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="135"
        r="6.5"
        fill={fillColor || 'url(#paint138_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint139_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="135"
        r="6.5"
        fill={fillColor || 'url(#paint140_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint141_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="135"
        r="6.5"
        fill={fillColor || 'url(#paint142_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint143_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="151"
        r="6.5"
        fill={fillColor || 'url(#paint144_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint145_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="151"
        r="6.5"
        fill={fillColor || 'url(#paint146_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint147_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="151"
        r="6.5"
        fill={fillColor || 'url(#paint148_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint149_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="151"
        r="6.5"
        fill={fillColor || 'url(#paint150_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint151_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="151"
        r="6.5"
        fill={fillColor || 'url(#paint152_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint153_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="151"
        r="6.5"
        fill={fillColor || 'url(#paint154_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint155_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="151"
        r="6.5"
        fill={fillColor || 'url(#paint156_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint157_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="151"
        r="6.5"
        fill={fillColor || 'url(#paint158_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint159_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="167"
        r="6.5"
        fill={fillColor || 'url(#paint160_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint161_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="167"
        r="6.5"
        fill={fillColor || 'url(#paint162_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint163_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="167"
        r="6.5"
        fill={fillColor || 'url(#paint164_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint165_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="167"
        r="6.5"
        fill={fillColor || 'url(#paint166_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint167_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="167"
        r="6.5"
        fill={fillColor || 'url(#paint168_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint169_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="167"
        r="6.5"
        fill={fillColor || 'url(#paint170_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint171_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="167"
        r="6.5"
        fill={fillColor || 'url(#paint172_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint173_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="167"
        r="6.5"
        fill={fillColor || 'url(#paint174_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint175_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="183"
        r="6.5"
        fill={fillColor || 'url(#paint176_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint177_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="183"
        r="6.5"
        fill={fillColor || 'url(#paint178_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint179_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="183"
        r="6.5"
        fill={fillColor || 'url(#paint180_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint181_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="183"
        r="6.5"
        fill={fillColor || 'url(#paint182_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint183_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="183"
        r="6.5"
        fill={fillColor || 'url(#paint184_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint185_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="183"
        r="6.5"
        fill={fillColor || 'url(#paint186_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint187_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="183"
        r="6.5"
        fill={fillColor || 'url(#paint188_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint189_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="183"
        r="6.5"
        fill={fillColor || 'url(#paint190_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint191_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="199"
        r="6.5"
        fill={fillColor || 'url(#paint192_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint193_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="199"
        r="6.5"
        fill={fillColor || 'url(#paint194_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint195_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="199"
        r="6.5"
        fill={fillColor || 'url(#paint196_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint197_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="199"
        r="6.5"
        fill={fillColor || 'url(#paint198_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint199_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="199"
        r="6.5"
        fill={fillColor || 'url(#paint200_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint201_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="199"
        r="6.5"
        fill={fillColor || 'url(#paint202_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint203_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="199"
        r="6.5"
        fill={fillColor || 'url(#paint204_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint205_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="199"
        r="6.5"
        fill={fillColor || 'url(#paint206_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint207_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="215"
        r="6.5"
        fill={fillColor || 'url(#paint208_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint209_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="215"
        r="6.5"
        fill={fillColor || 'url(#paint210_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint211_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="215"
        r="6.5"
        fill={fillColor || 'url(#paint212_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint213_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="215"
        r="6.5"
        fill={fillColor || 'url(#paint214_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint215_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="215"
        r="6.5"
        fill={fillColor || 'url(#paint216_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint217_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="215"
        r="6.5"
        fill={fillColor || 'url(#paint218_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint219_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="215"
        r="6.5"
        fill={fillColor || 'url(#paint220_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint221_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="215"
        r="6.5"
        fill={fillColor || 'url(#paint222_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint223_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="231"
        r="6.5"
        fill={fillColor || 'url(#paint224_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint225_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="231"
        r="6.5"
        fill={fillColor || 'url(#paint226_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint227_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="231"
        r="6.5"
        fill={fillColor || 'url(#paint228_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint229_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="231"
        r="6.5"
        fill={fillColor || 'url(#paint230_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint231_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="231"
        r="6.5"
        fill={fillColor || 'url(#paint232_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint233_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="231"
        r="6.5"
        fill={fillColor || 'url(#paint234_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint235_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="231"
        r="6.5"
        fill={fillColor || 'url(#paint236_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint237_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="231"
        r="6.5"
        fill={fillColor || 'url(#paint238_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint239_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="247"
        r="6.5"
        fill={fillColor || 'url(#paint240_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint241_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="247"
        r="6.5"
        fill={fillColor || 'url(#paint242_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint243_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="247"
        r="6.5"
        fill={fillColor || 'url(#paint244_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint245_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="247"
        r="6.5"
        fill={fillColor || 'url(#paint246_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint247_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="247"
        r="6.5"
        fill={fillColor || 'url(#paint248_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint249_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="247"
        r="6.5"
        fill={fillColor || 'url(#paint250_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint251_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="247"
        r="6.5"
        fill={fillColor || 'url(#paint252_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint253_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="247"
        r="6.5"
        fill={fillColor || 'url(#paint254_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint255_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="263"
        r="6.5"
        fill={fillColor || 'url(#paint256_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint257_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="263"
        r="6.5"
        fill={fillColor || 'url(#paint258_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint259_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="263"
        r="6.5"
        fill={fillColor || 'url(#paint260_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint261_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="263"
        r="6.5"
        fill={fillColor || 'url(#paint262_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint263_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="263"
        r="6.5"
        fill={fillColor || 'url(#paint264_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint265_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="263"
        r="6.5"
        fill={fillColor || 'url(#paint266_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint267_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="263"
        r="6.5"
        fill={fillColor || 'url(#paint268_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint269_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="263"
        r="6.5"
        fill={fillColor || 'url(#paint270_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint271_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="279"
        r="6.5"
        fill={fillColor || 'url(#paint272_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint273_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="279"
        r="6.5"
        fill={fillColor || 'url(#paint274_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint275_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="279"
        r="6.5"
        fill={fillColor || 'url(#paint276_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint277_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="279"
        r="6.5"
        fill={fillColor || 'url(#paint278_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint279_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="279"
        r="6.5"
        fill={fillColor || 'url(#paint280_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint281_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="279"
        r="6.5"
        fill={fillColor || 'url(#paint282_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint283_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="279"
        r="6.5"
        fill={fillColor || 'url(#paint284_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint285_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="279"
        r="6.5"
        fill={fillColor || 'url(#paint286_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint287_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="295"
        r="6.5"
        fill={fillColor || 'url(#paint288_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint289_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="295"
        r="6.5"
        fill={fillColor || 'url(#paint290_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint291_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="295"
        r="6.5"
        fill={fillColor || 'url(#paint292_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint293_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="295"
        r="6.5"
        fill={fillColor || 'url(#paint294_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint295_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="295"
        r="6.5"
        fill={fillColor || 'url(#paint296_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint297_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="295"
        r="6.5"
        fill={fillColor || 'url(#paint298_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint299_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="295"
        r="6.5"
        fill={fillColor || 'url(#paint300_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint301_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="295"
        r="6.5"
        fill={fillColor || 'url(#paint302_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint303_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="311"
        r="6.5"
        fill={fillColor || 'url(#paint304_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint305_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="311"
        r="6.5"
        fill={fillColor || 'url(#paint306_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint307_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="311"
        r="6.5"
        fill={fillColor || 'url(#paint308_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint309_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="311"
        r="6.5"
        fill={fillColor || 'url(#paint310_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint311_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="311"
        r="6.5"
        fill={fillColor || 'url(#paint312_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint313_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="311"
        r="6.5"
        fill={fillColor || 'url(#paint314_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint315_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="311"
        r="6.5"
        fill={fillColor || 'url(#paint316_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint317_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="311"
        r="6.5"
        fill={fillColor || 'url(#paint318_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint319_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="327"
        r="6.5"
        fill={fillColor || 'url(#paint320_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint321_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="327"
        r="6.5"
        fill={fillColor || 'url(#paint322_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint323_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="327"
        r="6.5"
        fill={fillColor || 'url(#paint324_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint325_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="327"
        r="6.5"
        fill={fillColor || 'url(#paint326_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint327_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="327"
        r="6.5"
        fill={fillColor || 'url(#paint328_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint329_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="327"
        r="6.5"
        fill={fillColor || 'url(#paint330_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint331_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="327"
        r="6.5"
        fill={fillColor || 'url(#paint332_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint333_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="327"
        r="6.5"
        fill={fillColor || 'url(#paint334_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint335_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="343"
        r="6.5"
        fill={fillColor || 'url(#paint336_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint337_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="343"
        r="6.5"
        fill={fillColor || 'url(#paint338_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint339_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="343"
        r="6.5"
        fill={fillColor || 'url(#paint340_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint341_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="343"
        r="6.5"
        fill={fillColor || 'url(#paint342_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint343_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="343"
        r="6.5"
        fill={fillColor || 'url(#paint344_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint345_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="343"
        r="6.5"
        fill={fillColor || 'url(#paint346_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint347_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="343"
        r="6.5"
        fill={fillColor || 'url(#paint348_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint349_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="343"
        r="6.5"
        fill={fillColor || 'url(#paint350_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint351_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="359"
        r="6.5"
        fill={fillColor || 'url(#paint352_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint353_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="359"
        r="6.5"
        fill={fillColor || 'url(#paint354_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint355_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="359"
        r="6.5"
        fill={fillColor || 'url(#paint356_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint357_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="359"
        r="6.5"
        fill={fillColor || 'url(#paint358_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint359_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="359"
        r="6.5"
        fill={fillColor || 'url(#paint360_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint361_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="359"
        r="6.5"
        fill={fillColor || 'url(#paint362_linear_313_21720)'}
        fillOpacity="0.9"
        stroke="url(#paint363_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="359"
        r="6.5"
        fill={fillColor || 'url(#paint364_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint365_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="359"
        r="6.5"
        fill={fillColor || 'url(#paint366_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint367_linear_313_21720)"
      />
      <circle
        cx="7"
        cy="375"
        r="6.5"
        fill={fillColor || 'url(#paint368_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint369_linear_313_21720)"
      />
      <circle
        cx="23"
        cy="375"
        r="6.5"
        fill={fillColor || 'url(#paint370_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint371_linear_313_21720)"
      />
      <circle
        cx="39"
        cy="375"
        r="6.5"
        fill={fillColor || 'url(#paint372_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint373_linear_313_21720)"
      />
      <circle
        cx="55"
        cy="375"
        r="6.5"
        fill={fillColor || 'url(#paint374_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint375_linear_313_21720)"
      />
      <circle
        cx="71"
        cy="375"
        r="6.5"
        fill={fillColor || 'url(#paint376_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint377_linear_313_21720)"
      />
      <circle
        cx="87"
        cy="375"
        r="6.5"
        fill={fillColor || 'url(#paint378_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint379_linear_313_21720)"
      />
      <circle
        cx="103"
        cy="375"
        r="6.5"
        fill={fillColor || 'url(#paint380_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint381_linear_313_21720)"
      />
      <circle
        cx="119"
        cy="375"
        r="6.5"
        fill={fillColor || 'url(#paint382_linear_313_21720)'}
        fillOpacity="0.4"
        stroke="url(#paint383_linear_313_21720)"
      />
      <defs>
        <linearGradient id="paint0_linear_313_21720" x1="1.72973" y1="1.4" x2="12.1175" y2="12.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint1_linear_313_21720" x1="7" y1="1" x2="7" y2="13" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint2_linear_313_21720" x1="17.7297" y1="1.4" x2="28.1175" y2="12.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint3_linear_313_21720" x1="23" y1="1" x2="23" y2="13" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint4_linear_313_21720" x1="33.7297" y1="1.4" x2="44.1175" y2="12.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint5_linear_313_21720" x1="39" y1="1" x2="39" y2="13" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint6_linear_313_21720" x1="49.7297" y1="1.4" x2="60.1175" y2="12.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint7_linear_313_21720" x1="55" y1="1" x2="55" y2="13" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint8_linear_313_21720" x1="65.7297" y1="1.4" x2="76.1175" y2="12.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint9_linear_313_21720" x1="71" y1="1" x2="71" y2="13" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint10_linear_313_21720" x1="81.7297" y1="1.4" x2="92.1175" y2="12.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint11_linear_313_21720" x1="87" y1="1" x2="87" y2="13" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint12_linear_313_21720" x1="97.7297" y1="1.4" x2="108.117" y2="12.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint13_linear_313_21720" x1="103" y1="1" x2="103" y2="13" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint14_linear_313_21720" x1="113.73" y1="1.4" x2="124.117" y2="12.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint15_linear_313_21720" x1="119" y1="1" x2="119" y2="13" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint16_linear_313_21720" x1="1.72973" y1="17.4" x2="12.1175" y2="28.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint17_linear_313_21720" x1="7" y1="17" x2="7" y2="29" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint18_linear_313_21720" x1="17.7297" y1="17.4" x2="28.1175" y2="28.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint19_linear_313_21720" x1="23" y1="17" x2="23" y2="29" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint20_linear_313_21720" x1="33.7297" y1="17.4" x2="44.1175" y2="28.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint21_linear_313_21720" x1="39" y1="17" x2="39" y2="29" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint22_linear_313_21720" x1="49.7297" y1="17.4" x2="60.1175" y2="28.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint23_linear_313_21720" x1="55" y1="17" x2="55" y2="29" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint24_linear_313_21720" x1="65.7297" y1="17.4" x2="76.1175" y2="28.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint25_linear_313_21720" x1="71" y1="17" x2="71" y2="29" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint26_linear_313_21720" x1="81.7297" y1="17.4" x2="92.1175" y2="28.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint27_linear_313_21720" x1="87" y1="17" x2="87" y2="29" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint28_linear_313_21720" x1="97.7297" y1="17.4" x2="108.117" y2="28.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint29_linear_313_21720" x1="103" y1="17" x2="103" y2="29" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint30_linear_313_21720" x1="113.73" y1="17.4" x2="124.117" y2="28.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint31_linear_313_21720" x1="119" y1="17" x2="119" y2="29" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint32_linear_313_21720" x1="1.72973" y1="33.4" x2="12.1175" y2="44.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint33_linear_313_21720" x1="7" y1="33" x2="7" y2="45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint34_linear_313_21720" x1="17.7297" y1="33.4" x2="28.1175" y2="44.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint35_linear_313_21720" x1="23" y1="33" x2="23" y2="45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint36_linear_313_21720" x1="33.7297" y1="33.4" x2="44.1175" y2="44.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint37_linear_313_21720" x1="39" y1="33" x2="39" y2="45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint38_linear_313_21720" x1="49.7297" y1="33.4" x2="60.1175" y2="44.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint39_linear_313_21720" x1="55" y1="33" x2="55" y2="45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint40_linear_313_21720" x1="65.7297" y1="33.4" x2="76.1175" y2="44.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint41_linear_313_21720" x1="71" y1="33" x2="71" y2="45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint42_linear_313_21720" x1="81.7297" y1="33.4" x2="92.1175" y2="44.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint43_linear_313_21720" x1="87" y1="33" x2="87" y2="45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint44_linear_313_21720" x1="97.7297" y1="33.4" x2="108.117" y2="44.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint45_linear_313_21720" x1="103" y1="33" x2="103" y2="45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint46_linear_313_21720" x1="113.73" y1="33.4" x2="124.117" y2="44.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint47_linear_313_21720" x1="119" y1="33" x2="119" y2="45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint48_linear_313_21720" x1="1.72973" y1="49.4" x2="12.1175" y2="60.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint49_linear_313_21720" x1="7" y1="49" x2="7" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint50_linear_313_21720" x1="17.7297" y1="49.4" x2="28.1175" y2="60.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint51_linear_313_21720" x1="23" y1="49" x2="23" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint52_linear_313_21720" x1="33.7297" y1="49.4" x2="44.1175" y2="60.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint53_linear_313_21720" x1="39" y1="49" x2="39" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint54_linear_313_21720" x1="49.7297" y1="49.4" x2="60.1175" y2="60.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint55_linear_313_21720" x1="55" y1="49" x2="55" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint56_linear_313_21720" x1="65.7297" y1="49.4" x2="76.1175" y2="60.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint57_linear_313_21720" x1="71" y1="49" x2="71" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint58_linear_313_21720" x1="81.7297" y1="49.4" x2="92.1175" y2="60.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint59_linear_313_21720" x1="87" y1="49" x2="87" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint60_linear_313_21720" x1="97.7297" y1="49.4" x2="108.117" y2="60.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint61_linear_313_21720" x1="103" y1="49" x2="103" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint62_linear_313_21720" x1="113.73" y1="49.4" x2="124.117" y2="60.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint63_linear_313_21720" x1="119" y1="49" x2="119" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint64_linear_313_21720" x1="1.72973" y1="65.4" x2="12.1175" y2="76.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint65_linear_313_21720" x1="7" y1="65" x2="7" y2="77" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint66_linear_313_21720" x1="17.7297" y1="65.4" x2="28.1175" y2="76.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint67_linear_313_21720" x1="23" y1="65" x2="23" y2="77" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint68_linear_313_21720" x1="33.7297" y1="65.4" x2="44.1175" y2="76.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint69_linear_313_21720" x1="39" y1="65" x2="39" y2="77" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint70_linear_313_21720" x1="49.7297" y1="65.4" x2="60.1175" y2="76.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint71_linear_313_21720" x1="55" y1="65" x2="55" y2="77" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint72_linear_313_21720" x1="65.7297" y1="65.4" x2="76.1175" y2="76.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint73_linear_313_21720" x1="71" y1="65" x2="71" y2="77" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint74_linear_313_21720" x1="81.7297" y1="65.4" x2="92.1175" y2="76.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint75_linear_313_21720" x1="87" y1="65" x2="87" y2="77" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint76_linear_313_21720" x1="97.7297" y1="65.4" x2="108.117" y2="76.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint77_linear_313_21720" x1="103" y1="65" x2="103" y2="77" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint78_linear_313_21720" x1="113.73" y1="65.4" x2="124.117" y2="76.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint79_linear_313_21720" x1="119" y1="65" x2="119" y2="77" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint80_linear_313_21720" x1="1.72973" y1="81.4" x2="12.1175" y2="92.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint81_linear_313_21720" x1="7" y1="81" x2="7" y2="93" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint82_linear_313_21720" x1="17.7297" y1="81.4" x2="28.1175" y2="92.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint83_linear_313_21720" x1="23" y1="81" x2="23" y2="93" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint84_linear_313_21720" x1="33.7297" y1="81.4" x2="44.1175" y2="92.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint85_linear_313_21720" x1="39" y1="81" x2="39" y2="93" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint86_linear_313_21720" x1="49.7297" y1="81.4" x2="60.1175" y2="92.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint87_linear_313_21720" x1="55" y1="81" x2="55" y2="93" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint88_linear_313_21720" x1="65.7297" y1="81.4" x2="76.1175" y2="92.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint89_linear_313_21720" x1="71" y1="81" x2="71" y2="93" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint90_linear_313_21720" x1="81.7297" y1="81.4" x2="92.1175" y2="92.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint91_linear_313_21720" x1="87" y1="81" x2="87" y2="93" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint92_linear_313_21720" x1="97.7297" y1="81.4" x2="108.117" y2="92.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint93_linear_313_21720" x1="103" y1="81" x2="103" y2="93" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint94_linear_313_21720" x1="113.73" y1="81.4" x2="124.117" y2="92.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint95_linear_313_21720" x1="119" y1="81" x2="119" y2="93" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint96_linear_313_21720" x1="1.72973" y1="97.4" x2="12.1175" y2="108.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint97_linear_313_21720" x1="7" y1="97" x2="7" y2="109" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint98_linear_313_21720" x1="17.7297" y1="97.4" x2="28.1175" y2="108.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint99_linear_313_21720" x1="23" y1="97" x2="23" y2="109" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint100_linear_313_21720" x1="33.7297" y1="97.4" x2="44.1175" y2="108.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint101_linear_313_21720" x1="39" y1="97" x2="39" y2="109" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint102_linear_313_21720" x1="49.7297" y1="97.4" x2="60.1175" y2="108.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint103_linear_313_21720" x1="55" y1="97" x2="55" y2="109" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint104_linear_313_21720" x1="65.7297" y1="97.4" x2="76.1175" y2="108.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint105_linear_313_21720" x1="71" y1="97" x2="71" y2="109" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint106_linear_313_21720" x1="81.7297" y1="97.4" x2="92.1175" y2="108.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint107_linear_313_21720" x1="87" y1="97" x2="87" y2="109" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint108_linear_313_21720" x1="97.7297" y1="97.4" x2="108.117" y2="108.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint109_linear_313_21720" x1="103" y1="97" x2="103" y2="109" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint110_linear_313_21720" x1="113.73" y1="97.4" x2="124.117" y2="108.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint111_linear_313_21720" x1="119" y1="97" x2="119" y2="109" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint112_linear_313_21720" x1="1.72973" y1="113.4" x2="12.1175" y2="124.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint113_linear_313_21720" x1="7" y1="113" x2="7" y2="125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint114_linear_313_21720" x1="17.7297" y1="113.4" x2="28.1175" y2="124.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint115_linear_313_21720" x1="23" y1="113" x2="23" y2="125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint116_linear_313_21720" x1="33.7297" y1="113.4" x2="44.1175" y2="124.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint117_linear_313_21720" x1="39" y1="113" x2="39" y2="125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint118_linear_313_21720" x1="49.7297" y1="113.4" x2="60.1175" y2="124.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint119_linear_313_21720" x1="55" y1="113" x2="55" y2="125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint120_linear_313_21720" x1="65.7297" y1="113.4" x2="76.1175" y2="124.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint121_linear_313_21720" x1="71" y1="113" x2="71" y2="125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint122_linear_313_21720" x1="81.7297" y1="113.4" x2="92.1175" y2="124.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint123_linear_313_21720" x1="87" y1="113" x2="87" y2="125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint124_linear_313_21720" x1="97.7297" y1="113.4" x2="108.117" y2="124.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint125_linear_313_21720" x1="103" y1="113" x2="103" y2="125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint126_linear_313_21720" x1="113.73" y1="113.4" x2="124.117" y2="124.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint127_linear_313_21720" x1="119" y1="113" x2="119" y2="125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint128_linear_313_21720" x1="1.72973" y1="129.4" x2="12.1175" y2="140.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint129_linear_313_21720" x1="7" y1="129" x2="7" y2="141" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint130_linear_313_21720" x1="17.7297" y1="129.4" x2="28.1175" y2="140.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint131_linear_313_21720" x1="23" y1="129" x2="23" y2="141" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint132_linear_313_21720" x1="33.7297" y1="129.4" x2="44.1175" y2="140.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint133_linear_313_21720" x1="39" y1="129" x2="39" y2="141" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint134_linear_313_21720" x1="49.7297" y1="129.4" x2="60.1175" y2="140.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint135_linear_313_21720" x1="55" y1="129" x2="55" y2="141" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint136_linear_313_21720" x1="65.7297" y1="129.4" x2="76.1175" y2="140.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint137_linear_313_21720" x1="71" y1="129" x2="71" y2="141" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint138_linear_313_21720" x1="81.7297" y1="129.4" x2="92.1175" y2="140.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint139_linear_313_21720" x1="87" y1="129" x2="87" y2="141" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint140_linear_313_21720" x1="97.7297" y1="129.4" x2="108.117" y2="140.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint141_linear_313_21720" x1="103" y1="129" x2="103" y2="141" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint142_linear_313_21720" x1="113.73" y1="129.4" x2="124.117" y2="140.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint143_linear_313_21720" x1="119" y1="129" x2="119" y2="141" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint144_linear_313_21720" x1="1.72973" y1="145.4" x2="12.1175" y2="156.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint145_linear_313_21720" x1="7" y1="145" x2="7" y2="157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint146_linear_313_21720" x1="17.7297" y1="145.4" x2="28.1175" y2="156.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint147_linear_313_21720" x1="23" y1="145" x2="23" y2="157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint148_linear_313_21720" x1="33.7297" y1="145.4" x2="44.1175" y2="156.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint149_linear_313_21720" x1="39" y1="145" x2="39" y2="157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint150_linear_313_21720" x1="49.7297" y1="145.4" x2="60.1175" y2="156.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint151_linear_313_21720" x1="55" y1="145" x2="55" y2="157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint152_linear_313_21720" x1="65.7297" y1="145.4" x2="76.1175" y2="156.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint153_linear_313_21720" x1="71" y1="145" x2="71" y2="157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint154_linear_313_21720" x1="81.7297" y1="145.4" x2="92.1175" y2="156.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint155_linear_313_21720" x1="87" y1="145" x2="87" y2="157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint156_linear_313_21720" x1="97.7297" y1="145.4" x2="108.117" y2="156.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint157_linear_313_21720" x1="103" y1="145" x2="103" y2="157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint158_linear_313_21720" x1="113.73" y1="145.4" x2="124.117" y2="156.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint159_linear_313_21720" x1="119" y1="145" x2="119" y2="157" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint160_linear_313_21720" x1="1.72973" y1="161.4" x2="12.1175" y2="172.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint161_linear_313_21720" x1="7" y1="161" x2="7" y2="173" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint162_linear_313_21720" x1="17.7297" y1="161.4" x2="28.1175" y2="172.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint163_linear_313_21720" x1="23" y1="161" x2="23" y2="173" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint164_linear_313_21720" x1="33.7297" y1="161.4" x2="44.1175" y2="172.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint165_linear_313_21720" x1="39" y1="161" x2="39" y2="173" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint166_linear_313_21720" x1="49.7297" y1="161.4" x2="60.1175" y2="172.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint167_linear_313_21720" x1="55" y1="161" x2="55" y2="173" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint168_linear_313_21720" x1="65.7297" y1="161.4" x2="76.1175" y2="172.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint169_linear_313_21720" x1="71" y1="161" x2="71" y2="173" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint170_linear_313_21720" x1="81.7297" y1="161.4" x2="92.1175" y2="172.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint171_linear_313_21720" x1="87" y1="161" x2="87" y2="173" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint172_linear_313_21720" x1="97.7297" y1="161.4" x2="108.117" y2="172.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint173_linear_313_21720" x1="103" y1="161" x2="103" y2="173" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint174_linear_313_21720" x1="113.73" y1="161.4" x2="124.117" y2="172.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint175_linear_313_21720" x1="119" y1="161" x2="119" y2="173" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint176_linear_313_21720" x1="1.72973" y1="177.4" x2="12.1175" y2="188.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint177_linear_313_21720" x1="7" y1="177" x2="7" y2="189" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint178_linear_313_21720" x1="17.7297" y1="177.4" x2="28.1175" y2="188.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint179_linear_313_21720" x1="23" y1="177" x2="23" y2="189" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint180_linear_313_21720" x1="33.7297" y1="177.4" x2="44.1175" y2="188.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint181_linear_313_21720" x1="39" y1="177" x2="39" y2="189" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint182_linear_313_21720" x1="49.7297" y1="177.4" x2="60.1175" y2="188.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint183_linear_313_21720" x1="55" y1="177" x2="55" y2="189" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint184_linear_313_21720" x1="65.7297" y1="177.4" x2="76.1175" y2="188.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint185_linear_313_21720" x1="71" y1="177" x2="71" y2="189" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint186_linear_313_21720" x1="81.7297" y1="177.4" x2="92.1175" y2="188.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint187_linear_313_21720" x1="87" y1="177" x2="87" y2="189" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint188_linear_313_21720" x1="97.7297" y1="177.4" x2="108.117" y2="188.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint189_linear_313_21720" x1="103" y1="177" x2="103" y2="189" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint190_linear_313_21720" x1="113.73" y1="177.4" x2="124.117" y2="188.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint191_linear_313_21720" x1="119" y1="177" x2="119" y2="189" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint192_linear_313_21720" x1="1.72973" y1="193.4" x2="12.1175" y2="204.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint193_linear_313_21720" x1="7" y1="193" x2="7" y2="205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint194_linear_313_21720" x1="17.7297" y1="193.4" x2="28.1175" y2="204.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint195_linear_313_21720" x1="23" y1="193" x2="23" y2="205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint196_linear_313_21720" x1="33.7297" y1="193.4" x2="44.1175" y2="204.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint197_linear_313_21720" x1="39" y1="193" x2="39" y2="205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint198_linear_313_21720" x1="49.7297" y1="193.4" x2="60.1175" y2="204.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint199_linear_313_21720" x1="55" y1="193" x2="55" y2="205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint200_linear_313_21720" x1="65.7297" y1="193.4" x2="76.1175" y2="204.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint201_linear_313_21720" x1="71" y1="193" x2="71" y2="205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint202_linear_313_21720" x1="81.7297" y1="193.4" x2="92.1175" y2="204.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint203_linear_313_21720" x1="87" y1="193" x2="87" y2="205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint204_linear_313_21720" x1="97.7297" y1="193.4" x2="108.117" y2="204.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint205_linear_313_21720" x1="103" y1="193" x2="103" y2="205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint206_linear_313_21720" x1="113.73" y1="193.4" x2="124.117" y2="204.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint207_linear_313_21720" x1="119" y1="193" x2="119" y2="205" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint208_linear_313_21720" x1="1.72973" y1="209.4" x2="12.1175" y2="220.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint209_linear_313_21720" x1="7" y1="209" x2="7" y2="221" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint210_linear_313_21720" x1="17.7297" y1="209.4" x2="28.1175" y2="220.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint211_linear_313_21720" x1="23" y1="209" x2="23" y2="221" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint212_linear_313_21720" x1="33.7297" y1="209.4" x2="44.1175" y2="220.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint213_linear_313_21720" x1="39" y1="209" x2="39" y2="221" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint214_linear_313_21720" x1="49.7297" y1="209.4" x2="60.1175" y2="220.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint215_linear_313_21720" x1="55" y1="209" x2="55" y2="221" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint216_linear_313_21720" x1="65.7297" y1="209.4" x2="76.1175" y2="220.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint217_linear_313_21720" x1="71" y1="209" x2="71" y2="221" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint218_linear_313_21720" x1="81.7297" y1="209.4" x2="92.1175" y2="220.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint219_linear_313_21720" x1="87" y1="209" x2="87" y2="221" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint220_linear_313_21720" x1="97.7297" y1="209.4" x2="108.117" y2="220.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint221_linear_313_21720" x1="103" y1="209" x2="103" y2="221" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint222_linear_313_21720" x1="113.73" y1="209.4" x2="124.117" y2="220.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint223_linear_313_21720" x1="119" y1="209" x2="119" y2="221" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint224_linear_313_21720" x1="1.72973" y1="225.4" x2="12.1175" y2="236.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint225_linear_313_21720" x1="7" y1="225" x2="7" y2="237" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint226_linear_313_21720" x1="17.7297" y1="225.4" x2="28.1175" y2="236.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint227_linear_313_21720" x1="23" y1="225" x2="23" y2="237" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint228_linear_313_21720" x1="33.7297" y1="225.4" x2="44.1175" y2="236.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint229_linear_313_21720" x1="39" y1="225" x2="39" y2="237" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint230_linear_313_21720" x1="49.7297" y1="225.4" x2="60.1175" y2="236.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint231_linear_313_21720" x1="55" y1="225" x2="55" y2="237" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint232_linear_313_21720" x1="65.7297" y1="225.4" x2="76.1175" y2="236.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint233_linear_313_21720" x1="71" y1="225" x2="71" y2="237" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint234_linear_313_21720" x1="81.7297" y1="225.4" x2="92.1175" y2="236.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint235_linear_313_21720" x1="87" y1="225" x2="87" y2="237" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint236_linear_313_21720" x1="97.7297" y1="225.4" x2="108.117" y2="236.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint237_linear_313_21720" x1="103" y1="225" x2="103" y2="237" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint238_linear_313_21720" x1="113.73" y1="225.4" x2="124.117" y2="236.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint239_linear_313_21720" x1="119" y1="225" x2="119" y2="237" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint240_linear_313_21720" x1="1.72973" y1="241.4" x2="12.1175" y2="252.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint241_linear_313_21720" x1="7" y1="241" x2="7" y2="253" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint242_linear_313_21720" x1="17.7297" y1="241.4" x2="28.1175" y2="252.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint243_linear_313_21720" x1="23" y1="241" x2="23" y2="253" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint244_linear_313_21720" x1="33.7297" y1="241.4" x2="44.1175" y2="252.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint245_linear_313_21720" x1="39" y1="241" x2="39" y2="253" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint246_linear_313_21720" x1="49.7297" y1="241.4" x2="60.1175" y2="252.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint247_linear_313_21720" x1="55" y1="241" x2="55" y2="253" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint248_linear_313_21720" x1="65.7297" y1="241.4" x2="76.1175" y2="252.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint249_linear_313_21720" x1="71" y1="241" x2="71" y2="253" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint250_linear_313_21720" x1="81.7297" y1="241.4" x2="92.1175" y2="252.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint251_linear_313_21720" x1="87" y1="241" x2="87" y2="253" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint252_linear_313_21720" x1="97.7297" y1="241.4" x2="108.117" y2="252.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint253_linear_313_21720" x1="103" y1="241" x2="103" y2="253" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint254_linear_313_21720" x1="113.73" y1="241.4" x2="124.117" y2="252.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint255_linear_313_21720" x1="119" y1="241" x2="119" y2="253" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint256_linear_313_21720" x1="1.72973" y1="257.4" x2="12.1175" y2="268.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint257_linear_313_21720" x1="7" y1="257" x2="7" y2="269" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint258_linear_313_21720" x1="17.7297" y1="257.4" x2="28.1175" y2="268.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint259_linear_313_21720" x1="23" y1="257" x2="23" y2="269" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint260_linear_313_21720" x1="33.7297" y1="257.4" x2="44.1175" y2="268.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint261_linear_313_21720" x1="39" y1="257" x2="39" y2="269" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint262_linear_313_21720" x1="49.7297" y1="257.4" x2="60.1175" y2="268.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint263_linear_313_21720" x1="55" y1="257" x2="55" y2="269" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint264_linear_313_21720" x1="65.7297" y1="257.4" x2="76.1175" y2="268.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint265_linear_313_21720" x1="71" y1="257" x2="71" y2="269" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint266_linear_313_21720" x1="81.7297" y1="257.4" x2="92.1175" y2="268.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint267_linear_313_21720" x1="87" y1="257" x2="87" y2="269" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint268_linear_313_21720" x1="97.7297" y1="257.4" x2="108.117" y2="268.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint269_linear_313_21720" x1="103" y1="257" x2="103" y2="269" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint270_linear_313_21720" x1="113.73" y1="257.4" x2="124.117" y2="268.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint271_linear_313_21720" x1="119" y1="257" x2="119" y2="269" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint272_linear_313_21720" x1="1.72973" y1="273.4" x2="12.1175" y2="284.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint273_linear_313_21720" x1="7" y1="273" x2="7" y2="285" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint274_linear_313_21720" x1="17.7297" y1="273.4" x2="28.1175" y2="284.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint275_linear_313_21720" x1="23" y1="273" x2="23" y2="285" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint276_linear_313_21720" x1="33.7297" y1="273.4" x2="44.1175" y2="284.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint277_linear_313_21720" x1="39" y1="273" x2="39" y2="285" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint278_linear_313_21720" x1="49.7297" y1="273.4" x2="60.1175" y2="284.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint279_linear_313_21720" x1="55" y1="273" x2="55" y2="285" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint280_linear_313_21720" x1="65.7297" y1="273.4" x2="76.1175" y2="284.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint281_linear_313_21720" x1="71" y1="273" x2="71" y2="285" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint282_linear_313_21720" x1="81.7297" y1="273.4" x2="92.1175" y2="284.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint283_linear_313_21720" x1="87" y1="273" x2="87" y2="285" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint284_linear_313_21720" x1="97.7297" y1="273.4" x2="108.117" y2="284.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint285_linear_313_21720" x1="103" y1="273" x2="103" y2="285" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint286_linear_313_21720" x1="113.73" y1="273.4" x2="124.117" y2="284.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint287_linear_313_21720" x1="119" y1="273" x2="119" y2="285" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint288_linear_313_21720" x1="1.72973" y1="289.4" x2="12.1175" y2="300.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint289_linear_313_21720" x1="7" y1="289" x2="7" y2="301" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint290_linear_313_21720" x1="17.7297" y1="289.4" x2="28.1175" y2="300.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint291_linear_313_21720" x1="23" y1="289" x2="23" y2="301" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint292_linear_313_21720" x1="33.7297" y1="289.4" x2="44.1175" y2="300.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint293_linear_313_21720" x1="39" y1="289" x2="39" y2="301" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint294_linear_313_21720" x1="49.7297" y1="289.4" x2="60.1175" y2="300.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint295_linear_313_21720" x1="55" y1="289" x2="55" y2="301" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint296_linear_313_21720" x1="65.7297" y1="289.4" x2="76.1175" y2="300.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint297_linear_313_21720" x1="71" y1="289" x2="71" y2="301" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint298_linear_313_21720" x1="81.7297" y1="289.4" x2="92.1175" y2="300.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint299_linear_313_21720" x1="87" y1="289" x2="87" y2="301" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint300_linear_313_21720" x1="97.7297" y1="289.4" x2="108.117" y2="300.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint301_linear_313_21720" x1="103" y1="289" x2="103" y2="301" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint302_linear_313_21720" x1="113.73" y1="289.4" x2="124.117" y2="300.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint303_linear_313_21720" x1="119" y1="289" x2="119" y2="301" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint304_linear_313_21720" x1="1.72973" y1="305.4" x2="12.1175" y2="316.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint305_linear_313_21720" x1="7" y1="305" x2="7" y2="317" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint306_linear_313_21720" x1="17.7297" y1="305.4" x2="28.1175" y2="316.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint307_linear_313_21720" x1="23" y1="305" x2="23" y2="317" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint308_linear_313_21720" x1="33.7297" y1="305.4" x2="44.1175" y2="316.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint309_linear_313_21720" x1="39" y1="305" x2="39" y2="317" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint310_linear_313_21720" x1="49.7297" y1="305.4" x2="60.1175" y2="316.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint311_linear_313_21720" x1="55" y1="305" x2="55" y2="317" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint312_linear_313_21720" x1="65.7297" y1="305.4" x2="76.1175" y2="316.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint313_linear_313_21720" x1="71" y1="305" x2="71" y2="317" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint314_linear_313_21720" x1="81.7297" y1="305.4" x2="92.1175" y2="316.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint315_linear_313_21720" x1="87" y1="305" x2="87" y2="317" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint316_linear_313_21720" x1="97.7297" y1="305.4" x2="108.117" y2="316.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint317_linear_313_21720" x1="103" y1="305" x2="103" y2="317" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint318_linear_313_21720" x1="113.73" y1="305.4" x2="124.117" y2="316.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint319_linear_313_21720" x1="119" y1="305" x2="119" y2="317" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint320_linear_313_21720" x1="1.72973" y1="321.4" x2="12.1175" y2="332.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint321_linear_313_21720" x1="7" y1="321" x2="7" y2="333" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint322_linear_313_21720" x1="17.7297" y1="321.4" x2="28.1175" y2="332.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint323_linear_313_21720" x1="23" y1="321" x2="23" y2="333" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint324_linear_313_21720" x1="33.7297" y1="321.4" x2="44.1175" y2="332.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint325_linear_313_21720" x1="39" y1="321" x2="39" y2="333" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint326_linear_313_21720" x1="49.7297" y1="321.4" x2="60.1175" y2="332.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint327_linear_313_21720" x1="55" y1="321" x2="55" y2="333" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint328_linear_313_21720" x1="65.7297" y1="321.4" x2="76.1175" y2="332.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint329_linear_313_21720" x1="71" y1="321" x2="71" y2="333" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint330_linear_313_21720" x1="81.7297" y1="321.4" x2="92.1175" y2="332.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint331_linear_313_21720" x1="87" y1="321" x2="87" y2="333" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint332_linear_313_21720" x1="97.7297" y1="321.4" x2="108.117" y2="332.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint333_linear_313_21720" x1="103" y1="321" x2="103" y2="333" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint334_linear_313_21720" x1="113.73" y1="321.4" x2="124.117" y2="332.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint335_linear_313_21720" x1="119" y1="321" x2="119" y2="333" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint336_linear_313_21720" x1="1.72973" y1="337.4" x2="12.1175" y2="348.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint337_linear_313_21720" x1="7" y1="337" x2="7" y2="349" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint338_linear_313_21720" x1="17.7297" y1="337.4" x2="28.1175" y2="348.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint339_linear_313_21720" x1="23" y1="337" x2="23" y2="349" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint340_linear_313_21720" x1="33.7297" y1="337.4" x2="44.1175" y2="348.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint341_linear_313_21720" x1="39" y1="337" x2="39" y2="349" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint342_linear_313_21720" x1="49.7297" y1="337.4" x2="60.1175" y2="348.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint343_linear_313_21720" x1="55" y1="337" x2="55" y2="349" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint344_linear_313_21720" x1="65.7297" y1="337.4" x2="76.1175" y2="348.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint345_linear_313_21720" x1="71" y1="337" x2="71" y2="349" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint346_linear_313_21720" x1="81.7297" y1="337.4" x2="92.1175" y2="348.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint347_linear_313_21720" x1="87" y1="337" x2="87" y2="349" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint348_linear_313_21720" x1="97.7297" y1="337.4" x2="108.117" y2="348.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint349_linear_313_21720" x1="103" y1="337" x2="103" y2="349" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint350_linear_313_21720" x1="113.73" y1="337.4" x2="124.117" y2="348.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint351_linear_313_21720" x1="119" y1="337" x2="119" y2="349" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint352_linear_313_21720" x1="1.72973" y1="353.4" x2="12.1175" y2="364.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint353_linear_313_21720" x1="7" y1="353" x2="7" y2="365" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint354_linear_313_21720" x1="17.7297" y1="353.4" x2="28.1175" y2="364.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint355_linear_313_21720" x1="23" y1="353" x2="23" y2="365" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint356_linear_313_21720" x1="33.7297" y1="353.4" x2="44.1175" y2="364.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint357_linear_313_21720" x1="39" y1="353" x2="39" y2="365" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint358_linear_313_21720" x1="49.7297" y1="353.4" x2="60.1175" y2="364.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint359_linear_313_21720" x1="55" y1="353" x2="55" y2="365" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint360_linear_313_21720" x1="65.7297" y1="353.4" x2="76.1175" y2="364.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint361_linear_313_21720" x1="71" y1="353" x2="71" y2="365" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint362_linear_313_21720" x1="81.7297" y1="353.4" x2="92.1175" y2="364.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#17181A" />
          <stop offset="1" stopColor="#090A0B" />
        </linearGradient>
        <linearGradient id="paint363_linear_313_21720" x1="87" y1="353" x2="87" y2="365" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint364_linear_313_21720" x1="97.7297" y1="353.4" x2="108.117" y2="364.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint365_linear_313_21720" x1="103" y1="353" x2="103" y2="365" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint366_linear_313_21720" x1="113.73" y1="353.4" x2="124.117" y2="364.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint367_linear_313_21720" x1="119" y1="353" x2="119" y2="365" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint368_linear_313_21720" x1="1.72973" y1="369.4" x2="12.1175" y2="380.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint369_linear_313_21720" x1="7" y1="369" x2="7" y2="381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint370_linear_313_21720" x1="17.7297" y1="369.4" x2="28.1175" y2="380.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint371_linear_313_21720" x1="23" y1="369" x2="23" y2="381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint372_linear_313_21720" x1="33.7297" y1="369.4" x2="44.1175" y2="380.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint373_linear_313_21720" x1="39" y1="369" x2="39" y2="381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint374_linear_313_21720" x1="49.7297" y1="369.4" x2="60.1175" y2="380.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint375_linear_313_21720" x1="55" y1="369" x2="55" y2="381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint376_linear_313_21720" x1="65.7297" y1="369.4" x2="76.1175" y2="380.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint377_linear_313_21720" x1="71" y1="369" x2="71" y2="381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint378_linear_313_21720" x1="81.7297" y1="369.4" x2="92.1175" y2="380.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint379_linear_313_21720" x1="87" y1="369" x2="87" y2="381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint380_linear_313_21720" x1="97.7297" y1="369.4" x2="108.117" y2="380.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint381_linear_313_21720" x1="103" y1="369" x2="103" y2="381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
        <linearGradient id="paint382_linear_313_21720" x1="113.73" y1="369.4" x2="124.117" y2="380.819" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202123" />
          <stop offset="1" stopColor="#0F1011" />
        </linearGradient>
        <linearGradient id="paint383_linear_313_21720" x1="119" y1="369" x2="119" y2="381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1F2123" stopOpacity="0" />
          <stop offset="1" stopColor="#474A4C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export { GeneratorBackgroundIcon };
